import PlanCard from '../PlanCard/PlanCard';
import styles from './PlanCardsList.module.scss';
import { useTranslation } from 'react-i18next';
import { usePaymentContext } from '../../../../context/PaymentContext';

const PlanCardsList = ({ plans }) => {
    const { t } = useTranslation(['payment']);
    const { selectedPlan } = usePaymentContext();

    if (!plans || plans.length === 0) {
        return <p className={styles.noPlans}>{t('noPlans')}</p>;
    }

    return (
        <div className={styles.plansContainer}>
            {plans.map((plan, index) => (
                <PlanCard
                    key={index}
                    plan={plan}
                    isSelected={selectedPlan?.stripeProductId === plan?.stripeProductId}
                />
            ))}
        </div>
    );
};

export default PlanCardsList;
